export const environment = {
  production: true,
  type: 'prod',
  BASE_URL: 'https://api.stolt.com/ccd-apis/',
  clientId: "a75790bf-9c0e-4ceb-9f35-9f65800fa260",
  authority: "https://login.microsoftonline.com/35d14ae1-4ee5-441b-a84a-6791dee05c7b",
  redirectUri: "https://ccd.stolttankers.com",
  GRAPH_ENDPOINT: 'https://graph.microsoft.com/v1.0/me',
  BACKEND_URL: 'https://api.stolt.com/ccd-apis/',
  USERSCOPE: 'api://32b7e946-0d0d-4ae2-9fee-f5019b9dcfa3/.default',
  GOOGLE_ANALYTICS: {
    googleAnalyticKey: 'G-1JCBG6F6DL',
  }
};